export default __webpack_public_path__ + "static/media/asteroides1.b84752bc.webp";